export default __webpack_public_path__ + "static/media/Levitate D5.1 Defining the future of urban transport.8f32ac74.pdf";